// extracted by mini-css-extract-plugin
export default {"group":"styles_group__lx7DZ","groupTitle":"styles_groupTitle__H2Wjj","buttons":"styles_buttons__8z6-p","pageBtn":"styles_pageBtn__sizKX"};